import React, { Component, PropTypes } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import '../../scss/components/_modal-container.scss';

export default class ModalContainer extends Component {
	element;
	blockClass = 'modal-container';

	componentWillMount() {
		if (this.props.open) {
			setTimeout(() => this.element.focus(), 0);
		}
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.open !== nextProps.open && nextProps.open) {
			setTimeout(() => this.element.focus(), 0);
		}
	}

	renderModal = () => {
		if (!this.props.open || !this.props.children) {
			return null;
		}

		return (
			<div
				ref={element => (this.element = element)}
				role="button"
				className={this.blockClass}
				onClick={this.handleClick}
				onKeyUp={this.handleKeyUp}
				tabIndex={0}>
				{this.props.children}
			</div>
		);
	};

	render() {
		return (
			<ReactCSSTransitionGroup
				transitionName={`${this.blockClass}-transition`}
				transitionEnterTimeout={200}
				transitionLeaveTimeout={200}>
				{this.renderModal()}
			</ReactCSSTransitionGroup>
		);
	}
}

ModalContainer.propTypes = {
	open: PropTypes.bool,
	children: PropTypes.node,
};



// WEBPACK FOOTER //
// ./src/assets/js/components/ModalContainer.js